import * as React from "react";
import { Modal, Box } from "@mui/material";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import { Typography } from "@mui/material";
import { MainInput, MainPassword } from "./Styles";
import { loginUser } from "../store/actions/authActions";
import { MarketingButton, MarketingFormCard } from "./marketing";
import { marketingColors, marketingFonts } from "./tickitMarketingTheme";

export const LoginModal = ({ open, handleClose, loginUser, isLoading }) => {
  const handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    loginUser({
      email: data.get("email"),
      password: data.get("password"),
    });
    handleClose();
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="login-modal-title"
      sx={{ display: "flex", alignItems: "center", justifyContent: "center", p: 2 }}
    >
      <Box sx={{ maxWidth: 440, width: "100%", outline: "none" }}>
        <MarketingFormCard
          title="Log in to Tickit"
          subtitle="Sign in to manage tickets and invitations"
          loading={isLoading}
          logoHeight={40}
        >
          <Box component="form" onSubmit={handleSubmit} sx={{ width: "100%" }}>
            <MainInput
              margin="normal"
              required
              fullWidth
              id="modal-email"
              label="Email"
              name="email"
              type="email"
              autoComplete="email"
              autoFocus
            />
            <MainPassword
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              id="modal-password"
              autoComplete="current-password"
            />
            <MarketingButton type="submit" fullWidth sx={{ mt: 2, mb: 1 }}>
              Log in
            </MarketingButton>
            <Typography sx={{ textAlign: "center", mt: 1, fontFamily: marketingFonts.body, fontSize: "0.875rem" }}>
              <NavLink to="/register" style={{ color: marketingColors.p700, fontWeight: 600 }}>
                Create an account
              </NavLink>
            </Typography>
          </Box>
        </MarketingFormCard>
      </Box>
    </Modal>
  );
};

const mapStateToProps = (state) => ({
  isLoading: state?.auth?.isLoading || state?.wait?.isLoading,
});

export default connect(mapStateToProps, { loginUser })(LoginModal);
